import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { ButtonType } from '../../../types/button.types';
import {
  ModalType,
  ModalTypeProperties
} from '../../molecules/simple-modal/models/simple-modal.interfaces';
import { SimpleModalComponent } from '../../molecules/simple-modal/simple-modal.component';
import {
  DropdownExpansionConfig,
  DropdownExpansionContent,
  DropdownExpansionStyles
} from './models/dropdown-expansion.interfaces';

@Component({
  selector: 'idp-dropdown-expansion',
  templateUrl: './dropdown-expansion.component.html',
  styleUrls: ['./dropdown-expansion.component.scss']
})
export class DropdownExpansionComponent
  extends SimpleModalComponent
  implements OnInit, OnChanges
{
  @Input() content: DropdownExpansionContent = {} as DropdownExpansionContent;
  @Input() config: DropdownExpansionConfig = {} as DropdownExpansionConfig;
  @Input() styles: DropdownExpansionStyles = {} as DropdownExpansionStyles;
  @Input() closeFromOutside = false;

  @Output() headerLinkClicked = new EventEmitter<boolean>();

  override typeProperties: ModalTypeProperties[] = [
    {
      type: ModalType.Default,
      classname: false,
      header: true,
      focus: true,
      footer: true
    },
    {
      type: ModalType.Minimal,
      classname: true,
      header: true,
      focus: true,
      footer: true
    },
    {
      type: ModalType.Accordion,
      classname: true,
      header: true,
      focus: false,
      footer: true
    }
  ];

  override ngOnInit() {
    const modalStyle = this.modalStyle as ButtonType;
    this.displayProperties = this.setDisplayProperties(this.type);
    this.modalType = this.modalStyle === 'advisory' ? 'primary' : modalStyle;
  }

  override ngOnChanges(change: SimpleChanges) {
    if (change['closeFromOutside']) {
      if (this.closeFromOutside) {
        this._open = false;
        this.setBackgroundScroll();
      }
    }
  }

  headerLinkClickEvent(): void {
    this.headerLinkClicked.emit(true);
  }

  menuIconClick(): void {
    this._open = !this._open;
    if (this.loadBackground && this._open) {
      this.setBackgroundScroll(true);
    }
  }
}
